module.exports = __webpack_public_path__ + "img/chris (19).95c61c34.jpg";